import { useTranslation } from 'react-i18next';

import { Panel } from 'components/containers';

import { CryptoPayoutStatusBadge } from 'pages/cryptoPayout/components/statusBadge';

import { CryptoPayoutStatus } from 'types/cryptoPayout';

import { formatFiatCurrencyI18n } from 'utils/i18n';

import { KEYS } from '../../keys';
import LABELS from './keys';
import { Container, Delimiter, Id, Item, ItemName, ItemValue } from './styles';

interface PayoutOutlineSectionProps {
  uuid: string;
  payoutTotal: number;
  status: CryptoPayoutStatus;
}

export const CryptoPayoutDetailsOutlineSection = ({ uuid, payoutTotal, status }: PayoutOutlineSectionProps) => {
  const { t, i18n } = useTranslation();
  const formattedAmount = formatFiatCurrencyI18n(i18n.language)(payoutTotal, KEYS.HARDCODED_CURRENCY);

  return (
    <Panel>
      <Container>
        <Item>
          <ItemName>{t(LABELS.UUID)}:</ItemName>
          <Id>{uuid}</Id>
        </Item>

        <Delimiter />

        <Item>
          <ItemName>{t(LABELS.AMOUNT)}:</ItemName>
          <ItemValue upper>{formattedAmount}</ItemValue>
        </Item>

        <Delimiter />

        <Item>
          <ItemName>{t(LABELS.STATUS)}:</ItemName>
          <ItemValue>
            <CryptoPayoutStatusBadge status={status} />
          </ItemValue>
        </Item>
      </Container>
    </Panel>
  );
};
